module.exports = __webpack_public_path__ + "img/slide11.6fb513aa.png";